import { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Error Boundary component that catches ChunkLoadErrors (caused by code splitting
 * when a new version is deployed) and automatically reloads the page.
 */
class ABSErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a ChunkLoadError (lazy loading failure)
    if (error.name === 'ChunkLoadError' ||
        (error.message && error.message.includes('Loading chunk')) ||
        (error.message && error.message.includes('Failed to fetch dynamically imported module'))) {
      return { hasError: true };
    }
    return null;
  }

  componentDidCatch(error, errorInfo) {
    // Reload the page when a chunk loading error is caught
    if (this.state.hasError) {
      window.location.reload();
    }
  }

  render() {
    // Return null while reloading to prevent further errors
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

ABSErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ABSErrorBoundary;